<ng-scrollbar #scrollable track="all">
    <div class="container-fluid text center" *ngIf="loader===false">
        <div class="row content">
            <div class="d-inline mt-1">
                <h1 class="ml-3">
        <span class="active-sprint-title">
               {{title}}
        </span>

                </h1>
            </div>

            <div class="d-inline mt-1">
                <button [disabled]="buttonDisabled===true"
                        (click)="completeSprints()"
                        *ngIf="adminPermission===true"
                        class="green-rounded-button ml-5">
                    Zatvori sprint
                </button>
            </div>

            <div class="col-xl-12 vh-100"
                 cdkDropListOrientation="horizontal"
                 cdkDropList
                 (cdkDropListDropped)="dropColumns($event)">
                <div class="board-example-box"
                     cdkDropListGroup>
                    <div cdkDrag
                         [cdkDragDisabled]="!adminPermission"
                         class="board-example-container"
                         [cdkDragData]="items"
                         *ngFor="let items of list;index as i">
                        <h2 #ignoredButton
                            cdkDragHandle
                            (click)="items.toggle=!items.toggle"
                            [id]="items.head"
                            [cpDisabled]="adminPermission==false"
                            class="board-column-header mr-3 mb-4"
                            [ngStyle]="{'background':items.color, 'border': '1px solid '+ items.color,'cursor': !adminPermission? 'context-menu':'move'}"
                            [style.background]="items.color" #ignoredInput
                            (colorPickerChange)="items.color=$event"
                            (colorPickerClose)="colorChange($event, items)"
                            [cpIgnoredElements]="[ignoredButton, ignoredInput]"
                            [(cpToggle)]="items.toggle"
                            [(colorPicker)]="items.color">
                            {{items.head}}
                        </h2>


                        <div cdkDropList
                             [id]="items.id"
                             #todoList="cdkDropList"
                             cdkDropListOrientation="horizontal"
                             [cdkDropListData]="items.items"
                             class="board-example-list"
                             (cdkDropListDropped)="drop($event)"
                             [cdkDropListConnectedTo]="trackIds">
                            <div [cdkDragData]="task"
                                 class="board-example-box board-task-card mb-3"
                                 *ngFor="let task of items.items"
                                 cdkDrag
                                 [ngStyle]="{'cursor': task.status ==='ddone' || task.status==='validated'? 'pointer':''}"
                                 [cdkDragDisabled]="task.status ==='ddone' || task.status==='validated'"
                            >

                                <div [routerLink]="['/view-task',task['_id']]"
                                     class="card-body board-task">
                                    <div class="full-width mb-2 text-left">
                                        <span class="active-sprint-status-badge" *ngIf="task['status']==='validated'">Odobren</span>
                                    </div>
                                    <div class="float-right mt-n1 mb-2 full-width"
                                    >

                                        <div class="media">
                                            <div class="media-body mr-2">
                                                <h4 class="mt-0 break-all">
                                                    {{task['title']}}</h4>
                                            </div>
                                            <app-avatar
                                                    [personalStyle]="task['type']==='meeting'? 'margin-top:4px;border: 2px solid white;left: 3%;':'margin-top:4px;border:2px solid white'"
                                                    [avatarWidth]="30"
                                                    [assigned]="assign"
                                                    *ngFor="let assign of task.assigned"></app-avatar>

                                        </div>
                                    </div>
                                    <div class="kanban-card-tags">
                                <span style="background: #4bc66c"
                                      class="badge badge-success "
                                      [ngClass]="{'ml-1':i>0}"
                                      *ngFor="let tag of task['tags'];index as i">
                                    {{tag}}
                                </span>
                                    </div>
                                    <div class="card-footer no-border bg-transparent kanban-card-attachments no-padding-left text-right no-padding-right">
                                        <div class="full-width" id="homethumbs">
                                            <div class="wrap d-inline-flex float-right">
                                                <div class="homethumb board-task-details">
                                            <span title="Podzadaci"
                                                  class="badge badge-info ml-1"
                                                  style="margin-top: 2px;margin-right: 5px;">
                                            <i class="lni lni-list"></i>
                                                {{task.sort === 'task' ? task.subtasks.length : 0}}
                                            </span>
                                                </div>
                                                <div class="homethumb board-task-details">
                                            <span title="Dokumenti" class="badge badge-success">
                                             <i class="lni lni-paperclip"></i>
                                                {{task.attachments.length}}
                                            </span>
                                                </div>
                                                <div class="homethumb board-task-details">
                                            <span title="Komentari" class="badge badge-success ml-1">
                                                <i class="lni lni-comments"></i>
                                                {{task.comments}}
                                            </span>
                                                </div>
                                                <div class="homethumb board-task-details">
                                            <span *ngIf="task.dayPast <0"
                                                  title="Rok je istekao pre {{task.dayPast * -1}} dana"
                                                  class="badge badge-danger ml-1"
                                                  style="margin-top: 2px;pointer-events: none;background: #f4433685;">
                                                {{task.dayPast * -1}} dana
                                                </span>
                                                    <span *ngIf="task.dayPast > 0"
                                                          title="{{task.dayPast}} dana do kraja roka"
                                                          class="badge badge-success ml-1 mr-1"
                                                          style="margin-top: 2px;pointer-events: none">
                                                    {{task.dayPast}} dana
                                                </span>
                                                    <span *ngIf="task.dayPast == 0" title=" Danas ističe rok."
                                                          class="badge badge-info ml-1"
                                                          style="margin-top: 2px;pointer-events: none">
                                                        Danas
                                                </span>
                                                </div>
                                            </div>


                                        </div>


                                    </div>
                                    <p class="my-0 wd-notif-blc-sep-label"
                                       [routerLink]="['/view-task',task['_id']]">
                                        Broj: {{task['identifier']}}</p>
                                </div>


                            </div>


                        </div>

                    </div>
                    <div class="board-example-container">
                        <div [ngStyle]="{'padding':newColumnButton?'0':'10px'}"
                             class="board-add-column-header board-add-column mr-3 overflow-hidden"
                             [ngClass]="{'input-group':newColumnButton===true }">
                            <div *ngIf="newColumnButton==false" id="notClicked">
                                <div>
                                    <button type="button"
                                            style="color:#a6a2a2 !important;"
                                            class="btn full-width no-padding no-border board-column-name"
                                            (click)="newColumnButton= !newColumnButton"
                                            [disabled]="!adminPermission"
                                            *ngIf="!newColumnButton">+
                                        Dodaj kolonu
                                    </button>

                                </div>

                            </div>


                            <input pattern="\S+.*" *ngIf="newColumnButton===true" type="text" placeholder="IME KOLONE"
                                   id="newColumn"
                                   [(ngModel)]="newColumnName">
                            <div *ngIf="newColumnButton===true" class="input-group-append">
                                <button class="btn active-sprint-checkmark"
                                        type="button"
                                        (click)="addColumn(board._id)">
                                    <i
                                            class="lni lni-checkmark bolder"></i>
                                </button>
                            </div>


                        </div>
                    </div>

                </div>


            </div>

        </div>


    </div>
</ng-scrollbar>
